'use strict';

function getCurrentPosition(successCallback, errorCallback) {
    let handled = false;

    navigator.geolocation.getCurrentPosition(
        function(position) {
            if (!handled) {
                handled = true;
                successCallback(position);
            }
        },
        function(error) {
            if (!handled) {
                handled = true;
                errorCallback(error);
            }
        }
    );
}

/**
 * Initialize geocode events
 * @param {Function} handleCurrentLocationClick
 * @requires jQuery
 * @returns {void}
 */
function initGeolocation(handleCurrentLocationClick) {
    const $currentLocation = $('.current-location-link');

    if ((!'geolocation' in navigator) || !window.hasOwnProperty('google')) {
        $currentLocation.addClass('d-none');
        return;
    }

    $currentLocation.on('click', handleCurrentLocationClick);
}

module.exports = {
    initGeolocation,
    getCurrentPosition
};